module.exports = __webpack_public_path__ + "img/Group 97720.2a900433.png";